export enum MessengerPositionEnum {
    MESSENGER_HOME = 'messenger_home',
    STORY = 'story',
    SPONSORED_MESSAGES = 'sponsored_messages'
}
export enum OldMessengerPosition {
    messenger_home,
    story,
    sponsored_messages
}